/**
 * src/shell/ui/screens/ReviewScreen.tsx — S7 评审报告屏（设计稿 §1.2 S7）。
 * schema 字段直读排版：五维分项 + 加权总分 + 盈亏 + EXP + 总评。
 */

import { COPY } from '../../copy'
import { useSave } from '../../gm-client/hooks'
import { DESK, type Screen } from '../nav'

const C = COPY.review
const DIMENSIONS = ['completion', 'creativity', 'art', 'game_feel', 'theme_fit'] as const

export function ReviewScreen({ projectId, go }: { projectId: string; go: (s: Screen) => void }) {
  const { bundle } = useSave()
  const project = bundle.projects.projects.find((p) => p.id === projectId)
  const review = bundle.reviews.reviews.find((r) => r.project_id === projectId)

  return (
    <div className="screen deep-screen">
      <button className="btn back-btn" type="button" onClick={() => go(DESK)}>
        {COPY.nav.backToDesk}
      </button>
      <div className="panel">
        <h3>{C.title}</h3>
        {project && <p className="dim">{project.idea.slice(0, 60)}</p>}
        {!review ? (
          <p className="dim">{COPY.shelf.reviewMissing}</p>
        ) : (
          <>
            <table className="ledger-table">
              <tbody>
                {DIMENSIONS.map((d) => (
                  <tr key={d}>
                    <td>{C.dimensions[d]}</td>
                    <td className="mono">{review.scores[d].score}</td>
                    <td className="dim">{review.scores[d].comment}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <table className="ledger-table">
              <tbody>
                <tr><td>{C.weighted}</td><td className="mono">{review.weighted_total}</td></tr>
                <tr><td>{C.revenue}</td><td className="mono">{review.revenue}</td></tr>
                <tr><td>{C.cost}</td><td className="mono">{review.cost}</td></tr>
                <tr>
                  <td>{C.profit}</td>
                  <td className="mono">{review.profit >= 0 ? '+' : ''}{review.profit}</td>
                </tr>
                <tr><td>{C.exp}</td><td className="mono">+{review.exp_gained}</td></tr>
              </tbody>
            </table>
            <h4>{C.marketFit}</h4>
            <p>{review.market_fit_notes}</p>
            <h4>{C.overall}</h4>
            <p>{review.overall_comment}</p>
          </>
        )}
      </div>
    </div>
  )
}
